import { createAPIConnection } from 'services';
import { BusinessUnitParams } from './interfaces';
import { requestHandler } from '../helpers';
import { getStore } from 'stores/helpers';

const api = createAPIConnection('/catalog', {
	onRequest(config) {
		const provider = getStore().customerReducer?.provider;

		if (provider !== 'PARCEIRO_HYPERA') Object.assign(config?.headers || {}, { 'Partner-origin': provider });
	},
});

export const getBUs = async (posId?: string) => {
	return requestHandler<BusinessUnitParams[]>(api.get('/business-unities', { params: { posId } }));
};
